import { FC } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmSaleSoDetailModel } from "../vrmBillSaleSoModel";
import { RouterParamType } from "@/model/navModel";
import { IDetailList } from "../vrmBillSaleSoType"
import { formatNum } from "@/utils/utils";

export const TableBox: FC<RouterParamType> = ({ id, mode, parentInfo }) => {
    const { detailLookList, } = useVrmSaleSoDetailModel();
    const columns: ColumnsType<IDetailList> = [
        {
            title: '序号',
            width: 80,
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编码',
            width: 120,
            dataIndex: 'materialCode',
            align: "center",
        }, {
            title: '商品名称',
            width: 120,
            dataIndex: 'materialName',
            align: "center",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
            align: "center",
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
            align: "center",
        },
        {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
            align: "center",
        }, {
            title: '销售数量',
            width: 120,
            dataIndex: 'num',
            align: "center",
        }, {
            title: '单价',
            width: 120,
            dataIndex: 'price',
            align: "center",
        }, {
            title: '销售金额',
            width: 120,
            dataIndex: 'totalAmount',
            align: "center",
        }, {
            title: '折扣',
            width: 120,
            dataIndex: 'discountRate',
            align: "center",
            render: (text: string) => text + '%'
        },
        {
            title: '折后金额',
            width: 100,
            dataIndex: 'discountedAmount',
            align: "center",
            render: (text) => formatNum(text),
        },
        {
            title: '单项优惠金额',
            width: 100,
            dataIndex: 'decreaseAmount',
            align: "center",
            render: (text) => `￥${formatNum(text)}`,
        },
        {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
            align: "center",
            render: (text) => `￥${formatNum(text)}`,
        },
        {
            title: '货位',
            width: 140,
            align: "center",
            dataIndex: 'shelfCode',
        },
        {
            title: '可用库存',
            width: 100,
            align: "center",
            dataIndex: 'inventoryNum',
        },
        {
            title: '采购单号',
            width: 160,
            align: "center",
            dataIndex: 'purchaseCode',
        },
        {
            title: '备注',
            width: 160,
            align: "center",
            dataIndex: 'note',
        }
    ];

    return (
        <YhBox title="配件信息" style={{ marginBottom: "75px" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={columns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}